import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import AppControllerSportsbookImpl from './app-controller-sportsbook.js';
const { UIControllerView } = MojitoCore.Presentation;

const propTypes = {
    location: PropTypes.object.isRequired,
};

export default UIControllerView('AppControllerSportsbook', AppControllerSportsbookImpl, propTypes);
